import React from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../Service/ApiService";
import formatCurrency from "./CurrencyFormatter";
import Title from "antd/es/typography/Title";
import { InfoCircleOutlined } from "@ant-design/icons";

const RoomResult = ({ roomSearchResults, currency, searchDates }) => {
  const navigate = useNavigate(); //initialise useNavigate hook
  const isAdmin = ApiService.isAdmin();
  return (
    <section className="room-results">
      {roomSearchResults && roomSearchResults.length > 0 ? (
        <div className="room-list">
          {roomSearchResults.map((room) => (
            <div key={room.id} className="room-list-item">
              <img
                className="room-list-item-image"
                src={room.roomPhotoUrl}
                alt={room.roomType}
              />
              <div className="room-details-container">
                <div className="room-details">
                  <h3>{room.roomType}</h3>
                  <p>Price: {formatCurrency(room.roomPrice, "en-US", currency)} per night</p>
                  <p>Description: {room.roomDescription}</p>
                </div>

                <div className="book-now-div">
                  {isAdmin ? (
                    <button
                      className="edit-room-button"
                      onClick={() => navigate(`/admin/edit-room/${room.id}`)} //navigate to edit
                    >
                      Edit Room
                    </button>
                  ) : (
                    <button
                      className="book-now-button"
                      onClick={() =>
                        navigate(`/room-details-book/${room.id}`, {
                          state: {
                            checkInDate: searchDates?.checkInDate ?? null,
                            checkOutDate: searchDates?.checkOutDate ?? null,
                          },
                        })
                      }
                    >
                      View/Book Now
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-results-container">
          <InfoCircleOutlined className="no-results-icon" />
          <Title
            level={2}
            style={{ color: "rgb(128, 128, 128)" }}
            className="no-results-title"
          >
            No Hotel Rooms Found
          </Title>
        </div>
      )}
    </section>
  );
};

export default RoomResult;
